import {FlagsTable} from './FlagsTable';

export function SignalerFlags() {
  return <FlagsTable />;
}
